
    // utils/vat.ts (ou en haut du composant)
export const normalizeVat = (raw: string): string =>
  raw.replace(/[\s.\-_/]/g, "").toUpperCase();

export const isValidVatMin9 = (raw: string): boolean => {
  const v = normalizeVat(raw);
  // Autorise lettres + chiffres (ex: BE0123456789) et exige ≥ 9 caractères
  return /^[A-Z0-9]{9,}$/.test(v);
};